var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M33.187.293H.807A.439.439 0 00.37.732v19.37c0 .242.196.439.439.439h6.204v.919c0 .639.438 1.157.977 1.157h18.067c.538 0 .977-.518.977-1.157v-.919h6.155a.44.44 0 00.439-.439V.732a.44.44 0 00-.44-.44zM26.154 21.46c0 .16-.073.262-.105.28H7.995c-.033-.018-.105-.12-.105-.28v-.919h18.264v.919zm6.594-1.797H1.247V1.17h31.501v18.492z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.883 19.203h30.23a.176.176 0 00.175-.176V1.807a.176.176 0 00-.176-.176H1.882a.176.176 0 00-.175.176v17.22c0 .097.079.176.176.176zm.175-17.22h29.878V18.85H2.058V1.982z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M16.997 3.348a7.077 7.077 0 00-7.069 7.069c0 3.897 3.171 7.069 7.07 7.069 3.897 0 7.068-3.172 7.068-7.069 0-3.898-3.171-7.07-7.069-7.07zm0 13.61a6.549 6.549 0 01-6.542-6.54 6.55 6.55 0 016.542-6.543 6.55 6.55 0 016.542 6.542 6.55 6.55 0 01-6.542 6.542z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M14.195 5.613a.263.263 0 00-.131.228v9.151a.263.263 0 00.394.228l7.926-4.575a.264.264 0 000-.457l-7.925-4.575a.265.265 0 00-.264 0zm.395.684l7.135 4.12-7.135 4.119V6.297z"
  }))));
}
export default SvgPersonalTv;